import { ComponentsModule } from '../../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { UserTaskAssignedListPage } from './user-task-assigned-list';

@NgModule({
  declarations: [UserTaskAssignedListPage],
  imports: [
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(UserTaskAssignedListPage),
    ComponentsModule,
  ],
})
export class UserTaskAssignedListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-assigned-list/user-task-assigned-list.module.ts